import { useIntl } from 'react-intl';
import { useMsal } from '@azure/msal-react';
import { useIsAuthenticated } from '@azure/msal-react';

import OnboardingHeader from '../OnboardingHeader';
import OnboardingFooter from '../OnboardingFooter';
import Button from 'src/componentes/button';

const MicrosoftStep = ({ onNext, onBack, currentStep, totalSteps }) => {
  const intl = useIntl();
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  const handleConnect = (isUserAuthenticated) => {
    if (!isUserAuthenticated) {
      instance
        .loginPopup({
          scopes: [],
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      instance.logoutPopup();
    }
  };

  const handleContinue = async () => {
    onNext();
  };

  const renderContent = () => (
    <>
      <h4 style={{ marginBottom: 10 }}>
        <strong>{intl.formatMessage({ id: 'integrarMicrosoft' })}</strong>
      </h4>

      <p style={{ color: '#6c757d', marginBottom: 24 }}>
        {intl.formatMessage({ id: 'condicaoIntegracaoMicrosoft' })}
      </p>

      <Button
        id={'conectarComMicrosoft'}
        key={'conectarComMicrosoft'}
        onClick={() => handleConnect(isAuthenticated)}
        outline
      >
        <img alt="Microsoft logo" src="/integracoes/microsoft-black.svg" />
        <div className="ml-2 font-weight-bold">
          {isAuthenticated ? (
            <span>{intl.formatMessage({ id: 'desconectarComMicrosoft' })}</span>
          ) : (
            <span id="desconectar">
              {intl.formatMessage({ id: 'conectarComMicrosoft' })}
            </span>
          )}
        </div>
      </Button>
    </>
  );

  return (
    <div
      style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
    >
      <OnboardingHeader currentStep={currentStep} totalSteps={totalSteps} />

      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ width: '60%', maxWidth: 600 }}>{renderContent()}</div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '60%', maxWidth: 600 }}>
          <OnboardingFooter onBack={onBack} onPrimaryAction={handleContinue} />
        </div>
      </div>
    </div>
  );
};

export default MicrosoftStep;
